import React from 'react'

import type { ResolvedExtra, ResolvedOption } from 'models/purchaseFlowRevamp'

import { usePfStore } from '../../store'
import { ExtraServicePicker } from './ExtraServicePicker.component'
import { OptionPicker } from './OptionPicker.component'
import type { useDrawerAddons } from './useDrawerAddons'

interface Props {
  options: ResolvedOption[]
  extras: ResolvedExtra[]
  handlers: Pick<ReturnType<typeof useDrawerAddons>, 'onSetOptionValue' | 'onClearOptionValue' | 'onToggleExtra'>
}

/** The add-ons and extra services of one drawer list, whichever wire array each arrived in. */
export const AddonLists: React.FC<Props> = ({ options, extras, handlers }) => {
  const shellProductId = usePfStore((s) => s.shellProductId)
  const optionValues = usePfStore((s) => s.optionValues)
  const selectedExtraIds = usePfStore((s) => s.selectedExtraIds)
  const extraQuantities = usePfStore((s) => s.extraQuantities)
  const setExtraQuantity = usePfStore((s) => s.setExtraQuantity)

  return (
    <>
      <OptionPicker
        options={options}
        values={optionValues}
        onSetValue={handlers.onSetOptionValue}
        onClearValue={handlers.onClearOptionValue}
        showHeading={false}
      />

      <ExtraServicePicker
        extras={extras}
        selectedExtraIds={selectedExtraIds}
        extraQuantities={extraQuantities}
        shellProductId={shellProductId}
        onToggle={handlers.onToggleExtra}
        onSetQuantity={setExtraQuantity}
      />
    </>
  )
}
